export default "__VITE_ASSET__TpTwRyoh__"